module.exports = __webpack_public_path__ + "static/media/info.a52a42b8.md";